import { TenantedClientApplicationReviewStateChoices } from "@graphql/generated/graphql.g";

import { Tag } from "@design-system/Tag/Tag";

type Props = {
  text: TenantedClientApplicationReviewStateChoices;
};

export const ReviewStateTag = ({ text }: Props) => {
  if (!text) {
    return null;
  }

  const colorMap: Record<
    TenantedClientApplicationReviewStateChoices,
    "danger" | "secondary" | "success" | "warning"
  > = {
    [TenantedClientApplicationReviewStateChoices.Discovered]: "secondary",
    [TenantedClientApplicationReviewStateChoices.Evaluating]: "warning",
    [TenantedClientApplicationReviewStateChoices.Approved]: "success",
    [TenantedClientApplicationReviewStateChoices.Unapproved]: "danger",
  };

  return <Tag color={colorMap[text]} text={text} />;
};
